import axios from "axios";
const host = process.env.REACT_APP_API_URL;

export async function sendOtp(data) {
  const res = await axios.post(`${host}auth/sendOtp`, data);
  // const res = await axios({
  //   url: host + "auth/sendOtp",
  //   method: "POST",
  //   data,
  // });
  return res;
}
export async function verifyOtp(data) {
  const res = await axios.post(`${host}auth/verifyOtp`, data);
  // const res = await axios({
  //   url: host + "auth/verifyOtp",
  //   method: "POST",
  //   data,
  // });
  return res;
}
export async function registerUser(data, regToken) {
  const res = await axios.post(`${host}auth/register`, data, {
    headers: {
      token: regToken,
    },
  });
  // const res = await axios({
  //   url: host + "auth/register",
  //   method: "POST",
  //   data,
  //   headers: {
  //     token: regToken,
  //   },
  // });
  return res;
}

export async function loginUser(data) {
  const res = await axios.post(`${host}auth/login`, data);
  // const res = await axios({
  //   url: host + "auth/login",
  //   method: "POST",
  //   data,
  // });
  return res;
}
export async function getDomainList() {
  const res = await axios.get(`${host}api/general/domainlist`);
  // const res = await axios({
  //   url: host + "api/general/domainlist",
  //   method: "GET",
  // });
  return res;
}
export async function getGenderList() {
  const res = await axios.get(`${host}api/general/genderlist`);
  // const res = await axios({
  //   url: host + "api/general/genderlist",
  //   method: "GET",
  // });
  return res;
}
export async function getDepartmentList() {
  const res = await axios.get(`${host}api/general/deptlist`);
  // const res = await axios({
  //   url: host + "api/general/deptlist",
  //   method: "GET",
  // });
  return res;
}
export async function sendOtpForgot(data) {
  const res = await axios.post(`${host}auth/forgot/sendOtp`, data);
  // const res = await axios({
  //   url: host + "auth/forgot/sendOtp",
  //   method: "POST",
  //   data,
  // });
  return res;
}
export async function verifyOtpForgot(data) {
  const res = await axios.post(`${host}auth/forgot/verifyOtp`, data);
  // const res = await axios({
  //   url: host + "auth/forgot/verifyOtp",
  //   method: "POST",
  //   data,
  // });
  return res;
}
export async function changePassword(data, regToken) {
  const res = await axios.put(`${host}auth/forgot/changePass`, data, {
    headers: {
      token: regToken,
    },
  });
  // const res = await axios({
  //   url: host + "auth/forgot/changePass",
  //   method: "PUT",
  //   data,
  //   headers: {
  //     token: regToken,
  //   },
  // });
  return res;
}